import { Float, Number } from './number.js';
export const ColorDefinition = (props = {}) => ({
    color: ColorRGB(props.color)
});
export const ColorRGBnormalize = (props = {}) => {
    var _a, _b, _c, _d;
    return ({
        red: Math.max(0, Math.min(255, (_a = Number(props.red)) !== null && _a !== void 0 ? _a : 0)),
        green: Math.max(0, Math.min(255, (_b = Number(props.green)) !== null && _b !== void 0 ? _b : 0)),
        blue: Math.max(0, Math.min(255, (_c = Number(props.blue)) !== null && _c !== void 0 ? _c : 0)),
        alpha: Math.max(0, Math.min(1, (_d = Float(props.alpha)) !== null && _d !== void 0 ? _d : 0))
    });
};
export const ColorRGB = (props) => ColorRGBnormalize(props);
ColorRGB.isValid = (color) => {
    return (color &&
        color.red >= 0 &&
        color.red <= 255 &&
        color.green >= 0 &&
        color.green <= 255 &&
        color.blue >= 0 &&
        color.blue <= 255 &&
        color.alpha >= 0 &&
        color.alpha <= 1);
};
export const rgbaToString = (color) => {
    if (!color)
        return;
    return `rgba(${color.red}, ${color.green}, ${color.blue}, ${color.alpha})`;
};
export function isColorReference(color) {
    return color && color.hasOwnProperty('id') && color.hasOwnProperty('alpha');
}
export function isColor(color) {
    return color && color.hasOwnProperty('red') && color.hasOwnProperty('green') && color.hasOwnProperty('blue');
}
export const gradientToBackgroundColor = (backgroundGradient) => backgroundGradient && backgroundGradient.stops.length > 0 ? backgroundGradient.stops[0].color : emptyColorReference;
export const backgroundColorToGradient = (backgroundColor) => {
    if (backgroundColor) {
        return {
            stops: [
                { color: backgroundColor, start: null, end: null },
                { color: backgroundColor, start: null, end: null }
            ],
            angle: 0
        };
    }
    return {
        stops: [],
        angle: 0
    };
};
export const emptyColorReference = { id: null, alpha: null };
export const findColor = (colorReference, colors) => {
    const color = colors.find((stylesColor) => stylesColor.details.id === colorReference.id);
    if (!color)
        return { colorGroup: null, colorDefinition: null };
};
export const findAlpha = (colorReference, colors) => {
    if (!colorReference)
        return 0;
    if (colorReference.alpha != null) {
        return colorReference.alpha;
    }
    for (const c of colors) {
        if (c.details.id === colorReference.id) {
            return c.props.alpha;
        }
    }
    return 0;
};
export const ColorReference = (color) => {
    var _a;
    if (!color) {
        return {
            id: null,
            alpha: null
        };
    }
    // Fixme: ColorReference accepting Colors is not type-safe concept.
    // Need to figure out how to deal with it another way.
    if (ColorRGB.isValid(color)) {
        return color;
    }
    let id = color.id || null;
    let alpha = (_a = color.alpha) !== null && _a !== void 0 ? _a : null;
    return {
        id,
        alpha
    };
};
ColorReference.isValid = (color) => {
    if (isColorReference(color)) {
        return color && color.id != null;
    }
    else if (isColor(color)) {
        return ColorRGB.isValid(color);
    }
};
export const areSameColors = (firstColor, secondColor) => (firstColor === null || firstColor === void 0 ? void 0 : firstColor.id) === (secondColor === null || secondColor === void 0 ? void 0 : secondColor.id);
//# sourceMappingURL=color.js.map